import React from 'react'
import title from './../../../assets/img/jpg/new_logo_promo_sairus.png'
import styles from './Title.module.scss'

interface ITitle {
	className?: string
}

const Title: React.FC<ITitle> = ({ className }) => {
	return (
		<div className={[styles.wrapper, className].join(' ')}>
			{/* <h1 className={[styles.h1_wrapper, styles.glow].join(" ")}>SAIRUS</h1>
            <h1 className={[styles.h1].join(" ")}>SAIRUS</h1>
            <div className={[styles.pixel, styles.pixel_1].join(" ")}></div>
            <div className={[styles.pixel, styles.pixel_2].join(" ")}></div>
            <div className={[styles.pixel, styles.pixel_3].join(" ")}></div>
            <div className={[styles.pixel, styles.pixel_4].join(" ")}></div>
            <div className={[styles.pixel, styles.pixel_5].join(" ")}></div> */}
			<img className={styles.svg} src={title} alt='' />
		</div>
	)
}

export default Title
